import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux-latest';
import FileUpload, { DropResult } from '../../../../components/file-upload';
import {
    addProspectsToImportProspects,
    resetImportProspects,
    updateProspectsFieldsInImportProspects,
} from '../../../../redux/actions';
import { AppDispatch } from '../../../../redux/store/configureStore';
import { ImportProspectsStepViewContainer } from '../containers';
import { UploadCSVContainer } from './containers';
import { CSV_LIMIT } from '../../../campaign/newCampaign/addProspects/prospectSearch/components/search-companies-modal/steps/modal-upload-list';

export const UploadCSV = () => {
    const dispatch = useDispatch<AppDispatch>();

    const handleResult = (result: DropResult) => {
        dispatch(addProspectsToImportProspects(result));
    };

    const handleHeaders = (headers: string[]) => {
        dispatch(updateProspectsFieldsInImportProspects(headers));
    };

    const handleResetAll = () => {
        dispatch(resetImportProspects());
    };

    return (
        <ImportProspectsStepViewContainer>
            <UploadCSVContainer>
                <Typography variant="h3">Upload list with prospects</Typography>
                <Typography className="description">
                    Upload an Excel or CSV list containing following requirements::
                </Typography>
                <div className="csv-upload-info-container">
                    <Typography>
                        1. Required Columns for <b>First name</b>, <b>Last Name</b>, <b>Company Name</b> and{' '}
                        <b>1 required Channel</b> (Email or LinkedIn)
                    </Typography>
                    <Typography>
                        2. Can additionally contain Columns for <b>Job Title</b>, <b>Prospect Location</b>,{' '}
                        <b>Full Name</b>, <b>Phone nr</b>, <b>Industry</b>, <b>Email</b>, <b>LinkedIn URL</b> and{' '}
                        <b>Website</b>
                    </Typography>
                    <Typography>{`3. Max ${CSV_LIMIT} prospects`}</Typography>
                </div>
                <FileUpload
                    onHeaders={handleHeaders}
                    onResult={handleResult}
                    dataValidator={({ results }) => {
                        const errors: string[] = [];

                        if (results.length > CSV_LIMIT) {
                            errors.push(`* Imported file has more than ${CSV_LIMIT} companies`);
                        }

                        return errors;
                    }}
                    onResetAll={handleResetAll}
                />
            </UploadCSVContainer>
        </ImportProspectsStepViewContainer>
    );
};
